import { Pipe, PipeTransform } from '@angular/core';

import { stripHtml } from '@celum/core/util';

@Pipe({
  name: 'stripHTML',
  pure: true
})
export class StripHtmlPipe implements PipeTransform {
  public transform(text: string): string {
    return stripHtml(text);
  }
}
